import { render, staticRenderFns } from "./IngredientCard.vue?vue&type=template&id=f8d95bc8&scoped=true&"
import script from "./IngredientCard.vue?vue&type=script&lang=js&"
export * from "./IngredientCard.vue?vue&type=script&lang=js&"
import style0 from "./IngredientCard.vue?vue&type=style&index=0&id=f8d95bc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d95bc8",
  null
  
)

export default component.exports